import { User } from "../model";
import { environment } from "../../environments/environment";
import Intercom, { show, showNewMessage, shutdown, update } from "@intercom/messenger-js-sdk";
import { UserService } from "../services/user/user.service";

export const showIntercom = () => {
  show();
};

export const showAndPrepopulateIntercom = (text: string) => {
  showNewMessage(text);
};

export const shutdownIntercom = () => {
  shutdown();
}

export const updateIntercomWithPackageContext = (integrationKey: string, integrationName: string, helpCenterArticleId?: string) => {
  update({
    current_integration_key: integrationKey,
    current_integration_name: integrationName,
    ...(helpCenterArticleId ? { current_integration_help_center_article_id: helpCenterArticleId } : {})
  });
};

export const bootIntercom = async (userService: UserService, language: string, user?: User) => {
  if (environment.intercomAppId) {
    if (!user) {
      // with jwt-security enforced, we currently can't boot intercom without a user (because we don't get the jwt token from the backend without a user)
      const STORAGE_KEY = "anonymousIntercomJwtUser";
      const userFromLS = window.sessionStorage?.getItem(STORAGE_KEY);
      if (!!userFromLS) {
        user = JSON.parse(userFromLS);
      } else {
        user = await userService.getAnonymousIntercomJwt();
        window.sessionStorage?.setItem(STORAGE_KEY, JSON.stringify(user));
      }
      if (!user) {
        // clear the session
        shutdown();
        return;
      }
    }

    if (user.cindyLoper) {
      // clear the session
      shutdown();
      return;
    }

    Intercom({
      app_id: environment.intercomAppId,
      intercom_user_jwt: user.intercomJwtToken,
      // The current logged-in user's full name (no longer needed; part of the jwt token)
      // name: user.name,
      // The current logged-in user's email address (no longer needed; part of the jwt token)
      // email: user.email,
      // The current logged-in user's sign-up date as a Unix timestamp.
      created_at: user.registrationTs !== 0 ? user.registrationTs : null,
      // user id
      user_id: !!user.intercomUserId ? ("" + user.intercomUserId) : null,
      // language setting
      language_override: language,
      // custom properties
      company_name: user.companyName,
      phone_number: user.telephoneNumber,
      hide_default_launcher: user.cindyLoper
    });
  }
};
